module.exports = __webpack_public_path__ + "assets/new-preview-background-portraite.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/new-preview-background-portraite.jpeg
// module id = 837
// module chunks = 0